import HttpClient from "application/services/http-client";
import { PaginationResponse } from "models/pagination-response";
import { IArticlesListRequest } from "models/request/articles-list-request";
import { IBannersListRequest } from "models/request/banners-list-request";
import { IExportDataRequest } from "models/request/export-data-request";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import { INewsPagedRequest } from "models/request/news-paged-request";
import { IOfficialDiaryPagedRequest } from "models/request/official-diary-paged-request";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";
import { IArticlesListResponse } from "models/response/articles-list-response";
import { IBannersListResponse } from "models/response/banners-list-response";
import { ICategoriesNewsListResponse } from "models/response/categories-news-list-response";
import { ICategoriesPublicationListResponnse } from "models/response/categories-publication-list-responnse";
import { FileDownloadResponse } from "models/response/file-download-response";
import { IGovernamentalStructureReponse } from "models/response/governamental-strutucture-response";
import { ILinkServicesListResponse } from "models/response/link-services-list-response";
import { INewsRespomse } from "models/response/news-response";
import { INewsPagedRespomse } from "models/response/news-paged-response";
import { IOfficialDiaryPagedResponse } from "models/response/official-diary-paged-response";
import { IPublicationPagedResponse } from "models/response/publication-paged-response";
import { IPublisingVehicleListReponse } from "models/response/publishing-vehicle-list-repsonse";
import { IMenusListRequest } from "models/request/menus-list-request";
import { IMenuResponse } from "models/response/menu-response";
import { ICustomPageRequest } from "models/request/custom-page-request";
import { ICustomPageResponse } from "models/response/custom-page-response";
import { ILicitacaoPagedRequest } from "models/request/licitacao-paged-request";
import { ILicitacaoPagedResponse } from "models/response/licitacao-paged-response";
import { IOrgaoResponse } from "models/response/orgao-response";
import { IUltimaAtualizacaoResponse } from "models/response/ultima-atualizacao-response";
import { IConvenioTotaisResponse } from "models/response/convenio-totais-response";
import { IEmendaParlamentarTotaisResponse } from "models/response/emenda-parlamentar-totais-response";
import { IModalidadeLicitacaoResponse } from "models/response/modalidade-licitacao-response";
import { IFaseLicitacaoResponse } from "models/response/fase-licitacao-response";
import { ISituacaoLicitacaoResponse } from "models/response/situacao-licitacao-response";
import { IConvenioPagedRequest } from "models/request/convenio-paged-request";
import { IConvenioPagedResponse } from "models/response/convenio-paged-response";
import { ISituacaoConvenioResponse } from "models/response/situacao-convenio-response";
import { IEmendaParlamentarPagedRequest } from "models/request/emenda-parlamentar-paged-request";
import { IEmendaParlamentarPagedResponse } from "models/response/emenda-parlamentar-paged-response";
import { ITipoEmendaResponse } from "models/response/tipo-emenda-response";
import { IFormaRepasseEmendaResponse } from "models/response/forma-repasse-emenda-response";
import { IContratoPagedRequest } from "models/request/contrato-paged-request";
import { IContratoPagedResponse } from "models/response/contrato-paged-response";
import { ITipoContratoResponse } from "models/response/tipo-contrato-response";
import { ISituacaoContratoResponse } from "models/response/situacao-contrato-response";
import { IPlanoContratacaoAnualResponse } from "models/response/plano-contratacao-anual-response";
import { IObraPagedRequest } from "models/request/obra-paged-request";
import { IObraPagedResponse } from "models/response/obra-paged-response";
import { ISituacaoObraResponse } from "models/response/situacao-obra-response";
import { IFuncaoObraResponse } from "models/response/funcao-obra-response";
import { ITipoObraResponse } from "models/response/tipo-obra-response";
import { IPrestacaoContasPagedRequest } from "models/request/prestacao-contas-paged-request";
import { IPrestacaoContasPagedResponse } from "models/response/prestacao-contas-paged-response";
import { ITipoDocumentoPrestacaoContasResponse } from "models/response/tipo-documento-prestacao-contas-response";
import { IPrestacaoContasTotaisResponse } from "models/response/prestacao-contas-totais-response";
import { IDocumentoSetorialPagedRequest } from "models/request/documento-setorial-paged-request";
import { IDocumentoSetorialPagedResponse } from "models/response/documento-setorial-paged-response";
import { ITipoDocumentoSetorialResponse } from "models/response/tipo-documento-setorial-response";
import { IAreaTransparenciaSetorialResponse } from "models/response/area-transparencia-setorial-response";
import { IDocumentoSetorialTotaisResponse } from "models/response/documento-setorial-totais-response";
import { IRepasseSetorialPagedRequest } from "models/request/repasse-setorial-paged-request";
import { IRepasseSetorialPagedResponse } from "models/response/repasse-setorial-paged-response";
import { IOrigemRepasseSetorialResponse } from "models/response/origem-repasse-setorial-response";
import { IRepasseSetorialTotaisResponse } from "models/response/repasse-setorial-totais-response";
import { IConselhoPagedRequest } from "models/request/conselho-paged-request";
import { IConselhoPagedResponse } from "models/response/conselho-paged-response";
import { IEstoqueMedicamentoPagedRequest } from "models/request/estoque-medicamento-paged-request";
import { IEstoqueMedicamentoPagedResponse } from "models/response/estoque-medicamento-paged-response";
import { IFilaEsperaPagedRequest } from "models/request/fila-espera-paged-request";
import { IFilaEsperaPagedResponse } from "models/response/fila-espera-paged-response";
import { ITipoFilaEsperaResponse } from "models/response/tipo-fila-espera-response";
import { IUnidadeSaudePagedRequest } from "models/request/unidade-saude-paged-request";
import { IUnidadeSaudePagedResponse } from "models/response/unidade-saude-paged-response";

const defaultPath = 'MunicipalPortal';


const listArticles = async (params: IArticlesListRequest): Promise<IArticlesListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Articles`,
        params: params
    }).then((response) => Object.assign([] as unknown as IArticlesListResponse, response.data));
};

const listBanners = async (params: IBannersListRequest): Promise<IBannersListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Banners`,
        params: params
    }).then((response) => response.data as IBannersListResponse[]);
};


const listLinkServices = async (params: ILinkServicesListRequest): Promise<ILinkServicesListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/LinkServices`,
        params: params
    }).then((response) => response.data as ILinkServicesListResponse[]);
};
const listCategoriesNews = async (): Promise<ICategoriesNewsListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoryNews`,
    }).then((response) => response.data as ICategoriesNewsListResponse[]);
};
const listNews = async (params: INewsPagedRequest): Promise<PaginationResponse<INewsPagedRespomse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<INewsPagedRespomse>(), response.data));
};
const listOfficialDaily = async (params: IOfficialDiaryPagedRequest): Promise<PaginationResponse<IOfficialDiaryPagedResponse>> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/OfficialDaily`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IOfficialDiaryPagedResponse>(), response.data));
};

const listPublication = async (params: IPublicationPagedReqeust): Promise<PaginationResponse<IPublicationPagedResponse>> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Publication`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IOfficialDiaryPagedResponse>(), response.data));
};
const listCategoryPublication = async (): Promise<ICategoriesPublicationListResponnse[]> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CategoriesPublication`,
    }).then((response) => Object.assign([] as ICategoriesPublicationListResponnse[], response.data));
};
const listPublisingVehicle = async (): Promise<IPublisingVehicleListReponse[]> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PublishingVehicle`,
    }).then((response) => Object.assign([] as IPublisingVehicleListReponse[], response.data));
};

const exportData = async (params: IExportDataRequest): Promise<FileDownloadResponse> => {

    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ExportData`,
        params: params
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const getGovernamentalStrucutre = async (id: number): Promise<IGovernamentalStructureReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as IGovernamentalStructureReponse, response.data));
};


const getNews = async (id: number): Promise<INewsRespomse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsRespomse, response.data));
};

const listGovernamentalSctructure = async (): Promise<IGovernamentalStructureReponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/GovernamentalStructure`
    }).then((response) => response.data as IGovernamentalStructureReponse[]);
};

const listMenus = async (): Promise<IMenuResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Menus`
    }).then((response) => response.data as IMenuResponse[]);
};

const getCustomPage = async (slug: string): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/CustomPages/${slug}`
    }).then((response) => Object.assign({} as ICustomPageResponse, response.data));
};


const listOrgaos = async (): Promise<IOrgaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Orgaos`
    }).then((response) => response.data);
};

const listComposicaoMesaDiretora = async (): Promise<any[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ComposicaoMesaDiretora`
    }).then((response) => response.data || []);
};

const listLicitacoes = async (params: ILicitacaoPagedRequest): Promise<PaginationResponse<ILicitacaoPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Licitacoes`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<ILicitacaoPagedResponse>(), response.data));
};

const getLicitacao = async (id: number): Promise<ILicitacaoPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Licitacoes/${id}`
    }).then((response) => Object.assign({} as ILicitacaoPagedResponse, response.data));
};

const exportLicitacaoDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Licitacoes/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listModalidadesLicitacao = async (): Promise<IModalidadeLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/ModalidadesLicitacao`
    }).then((response) => response.data || []);
};

const listFasesLicitacao = async (): Promise<IFaseLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FasesLicitacao`
    }).then((response) => response.data || []);
};

const listSituacoesLicitacao = async (): Promise<ISituacaoLicitacaoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SituacoesLicitacao`
    }).then((response) => response.data || []);
};

const getLicitacoesUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Licitacoes/UltimaAtualizacao`
    }).then((response) => response.data);
};

const exportLicitacoes = async (params: ILicitacaoPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Licitacoes/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listConvenios = async (params: IConvenioPagedRequest): Promise<PaginationResponse<IConvenioPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IConvenioPagedResponse>(), response.data));
};

const getConvenio = async (id: number): Promise<IConvenioPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios/${id}`
    }).then((response) => Object.assign({} as IConvenioPagedResponse, response.data));
};

const exportConvenioDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listSituacoesConvenio = async (): Promise<ISituacaoConvenioResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SituacoesConvenio`
    }).then((response) => response.data || []);
};

const getConveniosUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios/UltimaAtualizacao`
    }).then((response) => response.data);
};

const getConveniosTotais = async (params: { term?: string; idSituacaoConvenio?: number; dataInicio?: string; dataFim?: string }): Promise<IConvenioTotaisResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios/Totais`,
        params: params
    }).then((response) => response.data);
};

const exportConvenios = async (params: IConvenioPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Convenios/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listEmendasParlamentares = async (params: IEmendaParlamentarPagedRequest): Promise<PaginationResponse<IEmendaParlamentarPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IEmendaParlamentarPagedResponse>(), response.data));
};

const getEmendaParlamentar = async (id: number): Promise<IEmendaParlamentarPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares/${id}`
    }).then((response) => Object.assign({} as IEmendaParlamentarPagedResponse, response.data));
};

const exportEmendaParlamentarDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listTiposEmenda = async (): Promise<ITipoEmendaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposEmenda`
    }).then((response) => response.data || []);
};

const listFormasRepasseEmenda = async (): Promise<IFormaRepasseEmendaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FormasRepasseEmenda`
    }).then((response) => response.data || []);
};

const getEmendasParlamentaresUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares/UltimaAtualizacao`
    }).then((response) => response.data);
};

const getEmendasParlamentaresTotais = async (params: { term?: string; idTipoEmenda?: number; idFormaRepasseEmenda?: number; ano?: number }): Promise<IEmendaParlamentarTotaisResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares/Totais`,
        params: params
    }).then((response) => response.data);
};

const exportEmendasParlamentares = async (params: IEmendaParlamentarPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EmendasParlamentares/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listPrestacoesContas = async (params: IPrestacaoContasPagedRequest): Promise<PaginationResponse<IPrestacaoContasPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IPrestacaoContasPagedResponse>(), response.data));
};

const getPrestacaoContas = async (id: number): Promise<IPrestacaoContasPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas/${id}`
    }).then((response) => Object.assign({} as IPrestacaoContasPagedResponse, response.data));
};

const exportPrestacaoContasDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listTiposDocumentoPrestacaoContas = async (): Promise<ITipoDocumentoPrestacaoContasResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposDocumentoPrestacaoContas`
    }).then((response) => response.data || []);
};

const getPrestacoesContasUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas/UltimaAtualizacao`
    }).then((response) => response.data);
};

const getPrestacoesContasTotais = async (params: { term?: string; idTipoDocumentoPrestacaoContas?: number; ano?: number }): Promise<IPrestacaoContasTotaisResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas/Totais`,
        params: params
    }).then((response) => response.data);
};

const exportPrestacoesContas = async (params: IPrestacaoContasPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PrestacoesContas/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listDocumentosSetoriais = async (params: IDocumentoSetorialPagedRequest): Promise<PaginationResponse<IDocumentoSetorialPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IDocumentoSetorialPagedResponse>(), response.data));
};

const getDocumentoSetorial = async (id: number): Promise<IDocumentoSetorialPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais/${id}`
    }).then((response) => Object.assign({} as IDocumentoSetorialPagedResponse, response.data));
};

const exportDocumentoSetorialDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listTiposDocumentoSetorial = async (): Promise<ITipoDocumentoSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposDocumentoSetorial`
    }).then((response) => response.data || []);
};

const listAreasTransparenciaSetorial = async (): Promise<IAreaTransparenciaSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/AreasTransparenciaSetorial`
    }).then((response) => response.data || []);
};

const getDocumentosSetoriaisUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais/UltimaAtualizacao`
    }).then((response) => response.data);
};

const getDocumentosSetoriaisTotais = async (params: { term?: string; idTipoDocumentoSetorial?: number; idAreaTransparenciaSetorial?: number; ano?: number }): Promise<IDocumentoSetorialTotaisResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais/Totais`,
        params: params
    }).then((response) => response.data);
};

const exportDocumentosSetoriais = async (params: IDocumentoSetorialPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/DocumentosSetoriais/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listRepassesSetoriais = async (params: IRepasseSetorialPagedRequest): Promise<PaginationResponse<IRepasseSetorialPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IRepasseSetorialPagedResponse>(), response.data));
};

const getRepasseSetorial = async (id: number): Promise<IRepasseSetorialPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais/${id}`
    }).then((response) => Object.assign({} as IRepasseSetorialPagedResponse, response.data));
};

const exportRepasseSetorialDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listOrigensRepasseSetorial = async (): Promise<IOrigemRepasseSetorialResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/OrigensRepasseSetorial`
    }).then((response) => response.data || []);
};

const getRepassesSetoriaisUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais/UltimaAtualizacao`
    }).then((response) => response.data);
};

const getRepassesSetoriaisTotais = async (params: { term?: string; idAreaTransparenciaSetorial?: number; idOrigemRepasseSetorial?: number; ano?: number }): Promise<IRepasseSetorialTotaisResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais/Totais`,
        params: params
    }).then((response) => response.data);
};

const exportRepassesSetoriais = async (params: IRepasseSetorialPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/RepassesSetoriais/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listConselhos = async (params: IConselhoPagedRequest): Promise<PaginationResponse<IConselhoPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Conselhos`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IConselhoPagedResponse>(), response.data));
};

const getConselho = async (id: number): Promise<IConselhoPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Conselhos/${id}`
    }).then((response) => Object.assign({} as IConselhoPagedResponse, response.data));
};

const getConselhosUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Conselhos/UltimaAtualizacao`
    }).then((response) => response.data);
};

const exportConselhos = async (params: IConselhoPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Conselhos/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listEstoquesMedicamento = async (params: IEstoqueMedicamentoPagedRequest): Promise<PaginationResponse<IEstoqueMedicamentoPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EstoquesMedicamento`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IEstoqueMedicamentoPagedResponse>(), response.data));
};

const getEstoquesMedicamentoUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EstoquesMedicamento/UltimaAtualizacao`
    }).then((response) => response.data);
};

const exportEstoquesMedicamento = async (params: IEstoqueMedicamentoPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/EstoquesMedicamento/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listFilasEspera = async (params: IFilaEsperaPagedRequest): Promise<PaginationResponse<IFilaEsperaPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FilasEspera`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IFilaEsperaPagedResponse>(), response.data));
};

const getFilasEsperaUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FilasEspera/UltimaAtualizacao`
    }).then((response) => response.data);
};

const listTiposFilaEspera = async (): Promise<ITipoFilaEsperaResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposFilaEspera`
    }).then((response) => response.data || []);
};

const listUnidadesSaude = async (params: IUnidadeSaudePagedRequest): Promise<PaginationResponse<IUnidadeSaudePagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/UnidadesSaude`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IUnidadeSaudePagedResponse>(), response.data));
};

const getUnidadeSaude = async (id: number): Promise<IUnidadeSaudePagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/UnidadesSaude/${id}`
    }).then((response) => Object.assign({} as IUnidadeSaudePagedResponse, response.data));
};

const exportFilasEspera = async (params: IFilaEsperaPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FilasEspera/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listContratos = async (params: IContratoPagedRequest): Promise<PaginationResponse<IContratoPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Contratos`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IContratoPagedResponse>(), response.data));
};

const getContrato = async (id: number): Promise<IContratoPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Contratos/${id}`
    }).then((response) => Object.assign({} as IContratoPagedResponse, response.data));
};

const exportContratoDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Contratos/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listTiposContrato = async (): Promise<ITipoContratoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposContrato`
    }).then((response) => response.data || []);
};

const listSituacoesContrato = async (): Promise<ISituacaoContratoResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SituacoesContrato`
    }).then((response) => response.data || []);
};

const getContratosUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Contratos/UltimaAtualizacao`
    }).then((response) => response.data);
};

const exportContratos = async (params: IContratoPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Contratos/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listObras = async (params: IObraPagedRequest): Promise<PaginationResponse<IObraPagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Obras`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IObraPagedResponse>(), response.data));
};

const getObra = async (id: number): Promise<IObraPagedResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Obras/${id}`
    }).then((response) => Object.assign({} as IObraPagedResponse, response.data));
};

const exportObraDetail = async (id: number, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Obras/${id}/Export`,
        params: { format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listSituacoesObra = async (): Promise<ISituacaoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/SituacoesObra`
    }).then((response) => response.data || []);
};

const listFuncoesObra = async (): Promise<IFuncaoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/FuncoesObra`
    }).then((response) => response.data || []);
};

const listTiposObra = async (): Promise<ITipoObraResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/TiposObra`
    }).then((response) => response.data || []);
};

const getObrasUltimaAtualizacao = async (): Promise<IUltimaAtualizacaoResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Obras/UltimaAtualizacao`
    }).then((response) => response.data);
};

const exportObras = async (params: IObraPagedRequest, format: string): Promise<FileDownloadResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Obras/Export`,
        params: { ...params, format }
    }).then((response) => Object.assign({} as FileDownloadResponse, response.data));
};

const listPlanosContratacaoAnual = async (params: { page: number, pageSize: number, ano?: number }): Promise<PaginationResponse<IPlanoContratacaoAnualResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/PlanosContratacaoAnual`,
        params: params
    }).then((response) => Object.assign(new PaginationResponse<IPlanoContratacaoAnualResponse>(), response.data));
};

// Listas públicas do módulo Câmara Municipal: o backend devolve a lista completa da entidade e a tela filtra/pagina no cliente.
const listCamaraResource = async <T = any>(resource: string): Promise<T[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${resource}`
    }).then((response) => response.data || []);
};

const listVereadores = () => listCamaraResource('Vereadores');
const listSessoesLegislativas = () => listCamaraResource('SessoesLegislativas');
const listPresencasSessao = () => listCamaraResource('PresencasSessao');
const listProjetosLei = () => listCamaraResource('ProjetosLei');
const listAtosNormativos = () => listCamaraResource('AtosNormativos');
const listVotacoesNominais = () => listCamaraResource('VotacoesNominais');
const listCotasParlamentares = () => listCamaraResource('CotasParlamentares');
const listAtividadesParlamentares = () => listCamaraResource('AtividadesParlamentares');
const listComissoes = () => listCamaraResource('Comissoes');
const listPrestacoesContaExecutivo = () => listCamaraResource('PrestacoesContaExecutivo');

const MunicipalPortalAAppService = {
    listLinkServices, exportData, getGovernamentalStrucutre, listGovernamentalSctructure, getNews, listBanners, listPublisingVehicle, listArticles, listNews, listCategoriesNews, listOfficialDaily, listPublication, listCategoryPublication, listMenus, getCustomPage,
    listOrgaos, listComposicaoMesaDiretora, listLicitacoes, getLicitacao, listModalidadesLicitacao, listFasesLicitacao, listSituacoesLicitacao, getLicitacoesUltimaAtualizacao, exportLicitacoes, exportLicitacaoDetail,
    listConvenios, getConvenio, listSituacoesConvenio, getConveniosUltimaAtualizacao, exportConvenios, exportConvenioDetail, getConveniosTotais,
    listEmendasParlamentares, getEmendaParlamentar, listTiposEmenda, listFormasRepasseEmenda, getEmendasParlamentaresUltimaAtualizacao, exportEmendasParlamentares, exportEmendaParlamentarDetail, getEmendasParlamentaresTotais,
    listContratos, getContrato, listTiposContrato, listSituacoesContrato, getContratosUltimaAtualizacao, exportContratos, exportContratoDetail,
    listObras, getObra, listSituacoesObra, listFuncoesObra, listTiposObra, getObrasUltimaAtualizacao, exportObras, exportObraDetail,
    listPrestacoesContas, getPrestacaoContas, listTiposDocumentoPrestacaoContas, getPrestacoesContasUltimaAtualizacao, exportPrestacoesContas, exportPrestacaoContasDetail, getPrestacoesContasTotais,
    listDocumentosSetoriais, getDocumentoSetorial, listTiposDocumentoSetorial, listAreasTransparenciaSetorial, getDocumentosSetoriaisUltimaAtualizacao, exportDocumentosSetoriais, exportDocumentoSetorialDetail, getDocumentosSetoriaisTotais,
    listRepassesSetoriais, getRepasseSetorial, listOrigensRepasseSetorial, getRepassesSetoriaisUltimaAtualizacao, exportRepassesSetoriais, exportRepasseSetorialDetail, getRepassesSetoriaisTotais,
    listConselhos, getConselho, getConselhosUltimaAtualizacao, exportConselhos,
    listEstoquesMedicamento, getEstoquesMedicamentoUltimaAtualizacao, exportEstoquesMedicamento,
    listFilasEspera, getFilasEsperaUltimaAtualizacao, exportFilasEspera, listTiposFilaEspera,
    listUnidadesSaude, getUnidadeSaude,
    listPlanosContratacaoAnual,
    listVereadores, listSessoesLegislativas, listPresencasSessao, listProjetosLei, listAtosNormativos, listVotacoesNominais, listCotasParlamentares, listAtividadesParlamentares, listComissoes, listPrestacoesContaExecutivo
};

export default MunicipalPortalAAppService;